import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

interface PlannedHoursFieldProps {
  value: number | null;
  disabled?: boolean;
}

export function PlannedHoursField({ value, disabled }: Readonly<PlannedHoursFieldProps>) {
  return (
    <Box sx={{ py: 0.75, width: '100%' }}>
      <TextField
        value={value ?? ''}
        label="Planned Hours"
        disabled={disabled ?? true}
        fullWidth
        size="small"
        slotProps={{ htmlInput: { maxLength: 255 } }}
        required
      />
    </Box>
  );
}
